module.exports = __webpack_public_path__ + "img/outdoorCurtainHighmountDetector.ffb7e4d9.webp";